import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material'
import { getTranslation } from 'common'
import { useTranslations } from 'hooks';
import FlowentiLogo from "image/Logo.svg"
import { Link } from 'react-router-dom'

const Navbar = () => {
    const translations = useTranslations();

    return (
        <AppBar position="sticky" elevation={0} sx={{ backgroundColor: "#fff" }}>
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", maxWidth: 1200, width: '100%', mx: 'auto' }}>
                <Box component={Link} to="/" sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                    <img src={FlowentiLogo} alt="Flowenti Logo" style={{ height: 60 }} />
                    <Typography variant="h1" color="primary">Flowenti</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        id="support-button"
                        component={Link}
                        to="/support"
                        size="small"
                        variant="outlined"
                    >
                        {getTranslation(translations, "account.support.name")}
                    </Button>
                    <Button
                        component={Link}
                        to="/login"
                        size="small"
                        variant="outlined"
                    >
                        {getTranslation(translations, "register.signin.label")}
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default Navbar